import { render, staticRenderFns } from "./RegisteredVehicleList.vue?vue&type=template&id=0e37ec9b&scoped=true&"
import script from "./RegisteredVehicleList.vue?vue&type=script&lang=js&"
export * from "./RegisteredVehicleList.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredVehicleList.vue?vue&type=style&index=0&id=0e37ec9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e37ec9b",
  null
  
)

export default component.exports